/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Feature_2Inputs */

const en_search_feature_2 = /** @type {(inputs: Search_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`See search results ad-free`)
};

const id_search_feature_2 = /** @type {(inputs: Search_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lihat hasil penelusuran bebas iklan`)
};

const ms_search_feature_2 = /** @type {(inputs: Search_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lihat hasil carian tanpa iklan`)
};

const ca_search_feature_2 = /** @type {(inputs: Search_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gaudeix de resultats de cerca sense anuncis`)
};

const cs_search_feature_2 = /** @type {(inputs: Search_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Výsledky vyhledávání bez reklam`)
};

const da_search_feature_2 = /** @type {(inputs: Search_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se søgeresultater uden annoncer`)
};

const de_search_feature_2 = /** @type {(inputs: Search_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lass dir Suchergebnisse werbefrei anzeigen`)
};

const et_search_feature_2 = /** @type {(inputs: Search_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vaata otsingutulemusi reklaamivabalt`)
};

const es_search_feature_2 = /** @type {(inputs: Search_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ve resultados sin anuncios`)
};

const fr_search_feature_2 = /** @type {(inputs: Search_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profitez de résultats de recherche sans publicité`)
};

const hr_search_feature_2 = /** @type {(inputs: Search_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dobijte rezultate pretrage bez oglasa`)
};

const it_search_feature_2 = /** @type {(inputs: Search_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visualizza i risultati senza pubblicità`)
};

const lv_search_feature_2 = /** @type {(inputs: Search_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iegūstiet meklēšanas rezultātus bez reklāmām`)
};

const lt_search_feature_2 = /** @type {(inputs: Search_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Žiūrėkite paieškos rezultatus be reklamų`)
};

const hu_search_feature_2 = /** @type {(inputs: Search_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keresési találatok hirdetések nélkül`)
};

const nl_search_feature_2 = /** @type {(inputs: Search_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zoekresultaten zonder advertenties`)
};

const nb_search_feature_2 = /** @type {(inputs: Search_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Søkeresultater uten annonser`)
};

const pl_search_feature_2 = /** @type {(inputs: Search_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wyniki wyszukiwania bez reklam`)
};

const pt_search_feature_2 = /** @type {(inputs: Search_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veja os resultados da pesquisa sem anúncios`)
};

const ro_search_feature_2 = /** @type {(inputs: Search_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vezi rezultatele căutării fără reclame`)
};

const sk_search_feature_2 = /** @type {(inputs: Search_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Výsledky vyhľadávania bez reklám`)
};

const sl_search_feature_2 = /** @type {(inputs: Search_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oglejte si rezultate iskanja brez oglasov`)
};

const fi_search_feature_2 = /** @type {(inputs: Search_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Näe hakutulokset ilman mainoksia`)
};

const sv_search_feature_2 = /** @type {(inputs: Search_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se sökresultat utan annonser`)
};

const vi_search_feature_2 = /** @type {(inputs: Search_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xem kết quả tìm kiếm không có quảng cáo`)
};

const tr_search_feature_2 = /** @type {(inputs: Search_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arama sonuçlarını reklamsız görün`)
};

const el_search_feature_2 = /** @type {(inputs: Search_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Δείτε τα αποτελέσματα αναζήτησης χωρίς διαφημίσεις`)
};

const bg_search_feature_2 = /** @type {(inputs: Search_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Виждаш резултатите от търсенето без реклами`)
};

const ru_search_feature_2 = /** @type {(inputs: Search_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Смотрите результаты поиска без рекламы`)
};

const sr_search_feature_2 = /** @type {(inputs: Search_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Видите резултате претраге без огласа`)
};

const uk_search_feature_2 = /** @type {(inputs: Search_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Переглядати результати пошуку без реклами`)
};

const ka_search_feature_2 = /** @type {(inputs: Search_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`იხილეთ ძიების შედეგები რეკლამის გარეშე`)
};

const hi_search_feature_2 = /** @type {(inputs: Search_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ऐड-फ्री सर्च रिजल्ट्स देखें `)
};

const th_search_feature_2 = /** @type {(inputs: Search_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ดูผลการค้นหาโดยไม่มีโฆษณา`)
};

const ko_search_feature_2 = /** @type {(inputs: Search_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`광고 없이 검색 결과 보기`)
};

const zh_search_feature_2 = /** @type {(inputs: Search_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`查看无广告搜索结果`)
};

const zh_tw_search_feature_2 = /** @type {(inputs: Search_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`查看無廣告的搜尋結果`)
};

const ja_search_feature_2 = /** @type {(inputs: Search_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`広告のない検索結果`)
};

/**
* | output |
* | --- |
* | "See search results ad-free" |
*
* @param {Search_Feature_2Inputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const search_feature_2 = /** @type {((inputs?: Search_Feature_2Inputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Feature_2Inputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_search_feature_2(inputs)
	if (locale === "ms") return ms_search_feature_2(inputs)
	if (locale === "ca") return ca_search_feature_2(inputs)
	if (locale === "cs") return cs_search_feature_2(inputs)
	if (locale === "da") return da_search_feature_2(inputs)
	if (locale === "de") return de_search_feature_2(inputs)
	if (locale === "et") return et_search_feature_2(inputs)
	if (locale === "es") return es_search_feature_2(inputs)
	if (locale === "fr") return fr_search_feature_2(inputs)
	if (locale === "hr") return hr_search_feature_2(inputs)
	if (locale === "it") return it_search_feature_2(inputs)
	if (locale === "lv") return lv_search_feature_2(inputs)
	if (locale === "lt") return lt_search_feature_2(inputs)
	if (locale === "hu") return hu_search_feature_2(inputs)
	if (locale === "nl") return nl_search_feature_2(inputs)
	if (locale === "nb") return nb_search_feature_2(inputs)
	if (locale === "pl") return pl_search_feature_2(inputs)
	if (locale === "pt") return pt_search_feature_2(inputs)
	if (locale === "ro") return ro_search_feature_2(inputs)
	if (locale === "sk") return sk_search_feature_2(inputs)
	if (locale === "sl") return sl_search_feature_2(inputs)
	if (locale === "fi") return fi_search_feature_2(inputs)
	if (locale === "sv") return sv_search_feature_2(inputs)
	if (locale === "vi") return vi_search_feature_2(inputs)
	if (locale === "tr") return tr_search_feature_2(inputs)
	if (locale === "el") return el_search_feature_2(inputs)
	if (locale === "bg") return bg_search_feature_2(inputs)
	if (locale === "ru") return ru_search_feature_2(inputs)
	if (locale === "sr") return sr_search_feature_2(inputs)
	if (locale === "uk") return uk_search_feature_2(inputs)
	if (locale === "ka") return ka_search_feature_2(inputs)
	if (locale === "hi") return hi_search_feature_2(inputs)
	if (locale === "th") return th_search_feature_2(inputs)
	if (locale === "ko") return ko_search_feature_2(inputs)
	if (locale === "zh") return zh_search_feature_2(inputs)
	if (locale === "zh-tw") return zh_tw_search_feature_2(inputs)
	if (locale === "ja") return ja_search_feature_2(inputs)
	return en_search_feature_2(inputs)
});